import { Component, OnInit, OnDestroy } from '@angular/core';
import { PageMixin } from 'src/app/services/mixins/page.mixin';
import { PageService } from 'src/app/services/page.service';
import { ClientService } from 'src/app/services/client.service';
import { Title, Meta } from '@angular/platform-browser';
import { InfoService } from 'src/app/services/info.service';
import { LangService } from 'src/app/services/lang.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

import { BaseComponent } from '../../base.component';

@Component({
    selector: 'app-registration-confirm',
    templateUrl: './registration-confirm.component.html',
})
export class RegistrationConfirmComponent extends PageMixin(BaseComponent) implements OnInit, OnDestroy {
    public constructor(
        public page: PageService,
        private translate: TranslateService,
        protected client: ClientService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,
        public lang?: LangService,
    ) {
        super(page, title, meta, route, info);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.lang!.getLang().then((): Promise<any> => this.createTitle());

        $('body').addClass('bg-2');
    }

    public ngOnDestroy(): void {
        $('body').removeClass('bg-2');
    }

    /**
     * Create page title and meta
     * @return Promise<any>
     */
    private createTitle(): any {
        this.translate.get('web.title_registration_confirm').subscribe((): void => {
            const trans = this.translate.instant('web.title_registration_confirm');
            const client = this.client.getVName();
            this.setTitle(
                {
                    title: `${trans} | ${client}`,
                    description: this.translate.instant('web.description_registration_confirm'),
                },
                true,
            );
        });
    }
}
